var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJuiceBoxIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Juice_Box_icon_svg__clip0_1_40)",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 425.619H290.476V850c0 6.571 5.334 11.905 11.905 11.905h395.238c6.571 0 11.905-5.334 11.905-11.905V425.619H500z",
    fill: "#FEDF5B",
    stroke: "#FCB527",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.81 271.429H276.191c-13.155 0-23.81 10.654-23.81 23.809v185.714c0 21.036 17.06 38.096 38.095 38.096v-93.429h419.048v93.429c21.036 0 38.095-17.06 38.095-38.096V295.238c0-13.155-10.655-23.809-23.809-23.809z",
    fill: "#FFE888",
    stroke: "#FCC65B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M347.071 425.619h305.858",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 348l-190.476.524M309.524 309.524v78M690.476 348.524L500 348M690.476 309.524v78",
    stroke: "#FCB527",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.381 861.905h395.238c6.571 0 11.905-5.334 11.905-11.905V640.845l-36.75 63.655c-2.286 3.964-8.024 3.964-10.31 0l-31.595-54.726c-2.286-3.964-8.024-3.964-10.309 0L588.964 704.5c-2.285 3.964-8.024 3.964-10.309 0l-31.595-54.726c-2.286-3.964-8.024-3.964-10.31 0L505.155 704.5c-2.286 3.964-8.024 3.964-10.31 0l-31.595-54.726c-2.286-3.964-8.024-3.964-10.31 0L421.345 704.5c-2.285 3.964-8.024 3.964-10.309 0l-31.596-54.726c-2.285-3.964-8.023-3.964-10.309 0L337.536 704.5c-2.286 3.964-8.024 3.964-10.31 0l-36.75-63.655V850c0 6.571 5.334 11.905 11.905 11.905z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.69 557.143c-17.214 0-33.059 5.833-45.69 15.607-12.643-9.774-28.476-15.607-45.69-15.607-41.298 0-74.774 33.476-74.774 74.774 0 34.595 23.654 78.023 42.809 107.523 13.155 20.262 38.298 29.155 61.31 21.798a53.726 53.726 0 0132.678 0c23.012 7.357 48.155-1.536 61.31-21.798 19.155-29.5 42.809-72.916 42.809-107.523 0-41.298-33.476-74.774-74.773-74.774h.011z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.25 495.143c-18.81-8.512-44.036-3.107-62.119 14.988-18.095 18.095-23.5 43.309-14.988 62.119 18.809 8.512 44.036 3.107 62.119-14.988 18.095-18.095 23.5-43.31 14.988-62.119z",
    fill: "#46C65E",
    stroke: "#1E9561",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.071 343.774v.547c0 27.215 22.274 49.965 49.489 49.5 27.214-.464 47.797-22.095 47.797-48.631v-1.404c0-26.869-21.774-48.643-48.643-48.643s-48.643 21.774-48.643 48.643v-.012z",
    fill: "#FD934F",
    stroke: "#FD934F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.714 372.619c-15.774 0-28.571-12.798-28.571-28.571V172.619c0-15.774 12.797-28.571 28.571-28.571h95.238c15.774 0 28.572 12.797 28.572 28.571 0 15.774-12.798 28.571-28.572 28.571h-66.666v142.858c0 15.773-12.798 28.571-28.572 28.571z",
    fill: "#CAE0E3",
    stroke: "#95C2C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.476 201.19c15.78 0 28.572-12.791 28.572-28.571 0-15.78-12.792-28.571-28.572-28.571-15.779 0-28.571 12.791-28.571 28.571 0 15.78 12.792 28.571 28.571 28.571z",
    fill: "#88B1B5",
    stroke: "#95C2C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.095 671.429c21.04 0 38.095-17.056 38.095-38.096 0-21.039-17.055-38.095-38.095-38.095-21.039 0-38.095 17.056-38.095 38.095 0 21.04 17.056 38.096 38.095 38.096z",
    fill: "#F9697B",
    stroke: "#FA505E",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Juice_Box_icon_svg__clip0_1_40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuiceBoxIcon);
export default ForwardRef;